import { anyType } from "../types";
import { optionsType } from "../types/lib/createElements";

/* ****************************
 *  新規要素の作成
 * ****************************/ 
export const createNewElement = (tagName: string, options?: optionsType): HTMLElement => {
  const newElement = document.createElement(tagName);
  if(!options) { return newElement; }

  if(options.textContent) { newElement.textContent = options.textContent; }
  if(options.id) { newElement.id = options.id; }
  if(options.className) { newElement.className = options.className; }
  if(options.ariaHidden) { newElement.ariaHidden = options.ariaHidden; }
  if(options.style) { 
      Object.keys(options.style).forEach((key) => {
        if(!options.style) { return; }
        (newElement.style as anyType)[key] = options.style[key];
      });
  }
  if(options.buttonType && tagName === 'button') { (newElement as HTMLInputElement).type = options.buttonType; }
  if(options.childArr) { 
      options.childArr.forEach((child) => {
          newElement.appendChild(child);
      });
  }
  if (options.dataE2eTestId) {
    newElement.setAttribute("data-e2e-test-id", options.dataE2eTestId);
  }
  if(options.onClick) { newElement.addEventListener('click', options.onClick); }
  
  return newElement;
}
